import { Alert, AlertType } from 'components/alert/Alert';
import React, { Dispatch, ReactNode, SetStateAction, useMemo, useState } from 'react';

interface ReturnType {
  setMessage: Dispatch<SetStateAction<string | undefined>>;
  alertElement: ReactNode;
  hasError: boolean;
}

/**
 * A custom hook to use the alert component in an easy way
 */
function UseAlert(type: AlertType, closeable = true, onClosed?: () => void): ReturnType {
  const [message, setMessage] = useState<string | undefined>();

  /**
   * Render the alert element
   */
  const alertElement = useMemo(() => {
    return (
      message &&
      message !== '' && (
        <Alert
          type={type}
          text={message}
          onClose={
            closeable
              ? () => {
                  setMessage(undefined);
                  onClosed?.();
                }
              : undefined
          }
        />
      )
    );
  }, [closeable, message, onClosed, type]);

  return {
    setMessage,
    alertElement: alertElement,
    hasError: message !== undefined,
  };
}

export default UseAlert;
